const colors = {
    brand: {
        60: "#EFF6FF", // light background blue
        50: "#E3FCEC", //light green (mint)
        100: "#DBEAFE",
        150: "#A3CCF6",
        500: "#1E3A8A", // primary deep blue
        // 600: "#1E40AF",
        600: "#065F46",
    },
    teal: {
        500: "#14B8A6",
        400: "#47daca",
    },
    green: {
        // 100: "#D1FAE5", // scripture background
        100: "#BBF7D0", // scripture background
        400: "#10B981",
        700: "#047857",
    },
    gray: {
        500: "#4B5563", // muted text
        // 700: "#1F2937" // primary text
        700: "#2D3748" // primary text
    },
    darkBg: "#1A202C",
    lightBg: "#F7FAFC",
};

export default colors;